<template>
  <section>
    <el-col style="float:right; width: 38%; display:inline;   font-size:14px; margin: 5px 10px 10px 10px; "  >
      <div style=" float: right;padding-right: 8px;">
        <span :style="getStylecolor(0,4)">
        </span>
        任务取消
      </div>
      <div style="float: right; padding-right: 8px">
      <span :style="getStylecolor(0, 11)"> </span>
        任务异常已处理
      </div> 
      <div style=" float: right;padding-right: 8px;">
        <span :style="getStylecolor(0,3)">
        </span>
        任务异常
      </div>
      <div style="float: right; padding-right: 8px">
      <span :style="getStylecolor(0, 5)"> </span>
        已完成 
      </div>     
    </el-col>
    <!--工具条-->
    <TotalDetailsToolbar :buttonList="buttonList" @callFunction="callFunction"></TotalDetailsToolbar>

    <!--列表-->
    <el-table
      :data="totalDetailsList"
      highlight-current-row
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      style="width: 100%;"
    >
      <el-table-column fixed="left" type="index" label="序号" width="60"></el-table-column>          
     <!-- <el-table-column prop="DepartureDate" label="出车日期" width="160">
        <template slot-scope="scope">
          {{ scope.row.DepartureDate| dateYMDFormat }}
        </template> 
      </el-table-column>-->
      <el-table-column
        fixed="left"
        label="操作"
        width="90">
        <template slot-scope="scope">
          <span v-for="item in operationButtonList" :key="item.id">
          <el-button type="text" style="padding-right: 6px" size="small" v-if="!item.IsHide && item.name === '操作日记'" @click="operationButtonFunction(item, scope.row)">{{ item.name }}</el-button>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="DepartureDate" label="出车日期" :formatter="formatDepartureDate" width="120"></el-table-column>
      <el-table-column prop="LineName" label="线路名称" width="90"></el-table-column>
      <el-table-column prop="ShiftName" label="班次" width="80" sortable></el-table-column>
      <el-table-column prop="SelfMadeNumber" label="车辆自编号" width="120" sortable></el-table-column>
      <el-table-column prop="LicensePlateNumber" label="车牌号" width="100" sortable></el-table-column>
      <el-table-column prop="DriverName" label="司机" width="90" sortable></el-table-column>
      <el-table-column
        label="上行计划发车时间"
        width="350">
        <template slot-scope="scope">
          <span v-for="item in scope.row.runCenterHistoryTaskUpList" :key="item.id">
            <el-button type="text" v-if="!item.IsCharter&&item.DisposeResults!=null" :style="getStyle(1,11)" @click="handleShowDetails(item,scope.row.LineName,scope.row.LicensePlateNumber,scope.row.DriverName)">{{item.DepartureTimeStr}}</el-button>
            <el-button type="text" v-else-if="!item.IsCharter" :style="getStyle(1,item.State)" @click="handleShowDetails(item,scope.row.LineName,scope.row.LicensePlateNumber,scope.row.DriverName)">{{item.DepartureTimeStr}}</el-button>
            <el-button type="text" v-else :style="getStyle(1,0)" @click="handleShowDetails(item,scope.row.LineName,scope.row.LicensePlateNumber,scope.row.DriverName)">
              <div v-if="scope.row.ShiftName === '包车'" style="color:red;">包车</div> 
              <div v-else  >{{item.DepartureTimeStr}}</div>
              <div v-if="scope.row.ShiftName === '包车'">{{item.StartTimeStr}}</div> 
              <div v-if="scope.row.ShiftName === '包车'">{{item.EndTimeStr}}</div> 
              <div v-else style="color:red;">包车</div>
            </el-button>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="下行计划发车时间"
        width="350">
        <template slot-scope="scope">
          <span v-for="item in scope.row.runCenterHistoryTaskDownList" :key="item.id">
            <el-button type="text" v-if="!item.IsCharter&&item.DisposeResults!=null" :style="getStyle(1,11)" @click="handleShowDetails(item,scope.row.LineName,scope.row.LicensePlateNumber,scope.row.DriverName)">{{item.DepartureTimeStr}}</el-button>
            <el-button type="text" v-else-if="!item.IsCharter" :style="getStyle(1,item.State)" @click="handleShowDetails(item,scope.row.LineName,scope.row.LicensePlateNumber,scope.row.DriverName)">{{item.DepartureTimeStr}}</el-button>
            <el-button type="text" v-else :style="getStyle(1,0)" @click="handleShowDetails(item,scope.row.LineName,scope.row.LicensePlateNumber,scope.row.DriverName)">
              <div v-if="scope.row.ShiftName === '包车'" style="color:red;">包车</div> 
              <div v-else  >{{item.DepartureTimeStr}}</div>
              <div v-if="scope.row.ShiftName === '包车'">{{item.StartTimeStr}}</div> 
              <div v-if="scope.row.ShiftName === '包车'">{{item.EndTimeStr}}</div> 
              <div v-else style="color:red;">包车</div>
            </el-button>
          </span>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="Toolbar">
      <el-pagination
        layout="total, sizes, prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-sizes="[10, 15, 20, 50, 100, 200]"
        :total="total"
        style="float:right;"
      ></el-pagination>
    </el-col>

    <!--任务详情-->
    <el-dialog
      title="任务详情"
      :visible.sync="taskDetailsFormVisible"
      v-model="taskDetailsFormVisible"
      :close-on-click-modal="false"
      width="70%"
    >
      <el-table
        :data="totalDetailsDetails"
        highlight-current-row
        style="width: 100%;"
      >
        <el-table-column fixed="left" type="index" label="序号" width="60"></el-table-column>
        <el-table-column fixed="left" label="操作" width="210">
          <template slot-scope="scope">
            <span v-for="item in operationButtonList" :key="item.id"> 
              <el-button type="text" style="padding-right:6px;" size="small" v-if="!item.IsHide && item.name === '任务详情操作日记'||(item.name === '处理'&& (scope.row.State===3||(scope.row.State>5 && scope.row.State<11)))" @click="operationButtonFunction(item,scope.row)">{{item.name}}</el-button>
            </span>
          </template>
        </el-table-column>          
        <el-table-column fixed="left" prop="LineName" label="线路名称" width="80"></el-table-column>
        <el-table-column fixed="left" prop="ShiftName" label="班次" width="80"></el-table-column>
        <el-table-column prop="Times" label="趟次" width="60"></el-table-column>
        <el-table-column prop="LicensePlateNumber" label="车牌号" width="100"></el-table-column>
        <el-table-column prop="DriverName" label="司机" width="80"></el-table-column>
        <el-table-column label="计划发车时间" width="108" >
          <template slot-scope="scope">  
              <div v-if="scope.row.IsCharter === true"
                style="color:red;">{{scope.row.StartTimeStr + "--" + scope.row.EndTimeStr}}</div> 
              <div v-if="scope.row.IsCharter === false" >{{scope.row.DepartureTimeStr}}</div> 
          </template>
        </el-table-column> 
        <el-table-column label="发车地点" width="150" >
          <template slot-scope="scope">  
              <div v-if="scope.row.IsCharter === true"
                style="color:red;">{{scope.row.StartAddr + "--" + scope.row.EndAddr}}</div>               
          </template>
        </el-table-column>
  <!--      <el-table-column prop="DepartureTimeStr" label="计划发车时间" width="108"></el-table-column>-->
        <el-table-column prop="ActualDepartureTimeStr" label="实际发车时间" width="108"></el-table-column>
        <el-table-column prop="TimeDifference" label="发车时差(分)" width="108"></el-table-column>
        <el-table-column prop="StateName" label="状态" width="150"></el-table-column>
        <el-table-column prop="DisposeResultsName" label="处理结果" width="300"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="taskDetailsFormVisible = false">关闭</el-button>
      </div>
    </el-dialog>  
   
    <!--异常处理界面-->
    <el-dialog 
      title="异常处理" 
      :visible.sync="AbnormalFormVisible" 
      v-model="AbnormalFormVisible" 
      :close-on-click-modal="false"
      width="25%"
    >
      <el-form :model="AbnormalForm" label-width="80px" :rules="AbnormalFormRules" ref="AbnormalForm">
        <el-form-item label="处理结果" prop="DisposeResults" label-width="110px">
          <el-select style="width: 100%;" v-model="AbnormalForm.DisposeResults" placeholder="请选择处理结果">
            <el-option v-for="item in disposeResultsModeList" :key="item.Id" :value="item.DictCode" :label="item.DictName">
              <span style="float: left">{{ item.DictName }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="异常原因"  label-width="110px" >
            <el-input type="textarea" :autosize="{ minRows: 8, maxRows: 100}" v-model="AbnormalForm.AbnormalCause"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="AbnormalFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="AbnormalSubmit" :loading="AbnormalLoading">提交</el-button>
      </div>
    </el-dialog>
    <!--操作日记-->
    <el-dialog
      title="操作日记"
      :visible.sync="TwoTableOperateDataLogFormVisible"
      v-model="TwoTableOperateDataLogFormVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="60%"
    >
      <TwoTableOperateDataLog v-if="TwoTableOperateDataLogFormVisible" :oneEntityName="oneEntityName" :oneEntityKey="oneEntityKey" :twoEntityName="twoEntityName" :twoEntityKey="twoEntityKey"></TwoTableOperateDataLog>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="TwoTableOperateDataLogFormVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import { getTotalDetailsListPage, getBusLinesListPage, getDriverListPage, getVehiclesListPage, exportTotalDetails, getClassSubitem,getDictionaryListPageByDictNameAndDictCode,AbnormalDisposeUser,} from "../../api/api";
import { getButtonList, getOperationButtonList } from "../../promissionRouter";
import TotalDetailsToolbar from "../../components/QueryToolbar/TotalDetailsToolbar"; 
import { currentDate } from '../../baseCommon.js';
import TwoTableOperateDataLog from "../../components/TwoTableOperateDataLog";

export default {
  components: { TotalDetailsToolbar,TwoTableOperateDataLog },
  data() {
    return {
      filters: {
          busLinesId:"", //线路ID
          driverId:"", //驾驶员Id
          vehicleId:"", //驾驶员Id
          departureDate: [] //出车时间
      },       
      oneEntityName: '', //操作日记中的第一张表名称
      oneEntityKey: '', //操作日记中的第一张表的Id
      twoEntityName:'',//操作日记中的第二张表名称
      twoEntityKey:'',//操作日记中的第二张表的Id
      buttonList: [],        
      operationButtonList: [],
      disposeResultsModeList: [], //处理结果列表
      runCenterTaskList: [], //运行中心任务列表
      driverList: [], //驾驶员列表
      vehicleList: [], //车辆列表
      totalDetailsList: [],
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      taskDetailsFormVisible: false,
      TwoTableOperateDataLogFormVisible: false, //查看操作日记界面是否显示        
      totalDetailsDetails: [],//统计明细任务详细数据      
      AbnormalFormVisible: false, //异常处理界面是否显示
      AbnormalLoading: false,
      AbnormalFormRules: {
        DisposeResults: [
          { required: true, message: "请选择处理结果", trigger: "blur" },
        ],
        AbnormalCause: [
          { required: true, message: "请输入异常原因", trigger: "blur" },
        ],
      },
      //异常处理界面数据
      AbnormalForm: {
        DisposeResultsName: "" ,
        AbnormalCause:"",
        Id: 0
      },         
    };
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
          busLinesId: item.busLinesId,
          driverId: item.driverId,
          vehicleId: item.vehicleId,
          departureDate: (item.departureDate !== null && item.departureDate.length>0)?item.departureDate.toString():""
      };
      this.getTotalDetails();
      this[item.Func].apply(this, item);
    },     
    operationButtonFunction(item,row){
    this.currentRow = row;
    this[item.Func].apply(this,item);
   },
    handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      this.getTotalDetails();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getTotalDetails();
    },
   
    formatDepartureDate: function(row, column) {
      return !row.DepartureDate || row.DepartureDate == ""
        ? ""
        : util.formatDate.format(new Date(row.DepartureDate), "yyyy-MM-dd");
    },
    //导出任务数据
    handleExportTotalDetails() {
      let _this = this;
      let para = {
        busLinesId: _this.filters.busLinesId,
        vehicleId: _this.filters.vehicleId,
        driverId: _this.filters.driverId,          
        departureDate: (_this.filters.departureDate !== null && _this.filters.departureDate.length>0)?_this.filters.departureDate.toString():""          
      };
      exportTotalDetails(para).then(res => {
        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel",
        }); // 2.获取请求返回的response对象中的blob 设置文件类型，这里以excel为例
        let url = window.URL.createObjectURL(blob); // 3.创建一个临时的url指向blob对象
        // 4.创建url之后可以模拟对此文件对象的一系列操作，例如：预览、下载
        let a = document.createElement("a");
        a.href = url;
        a.download = "统计明细" + currentDate() + "日数据.xlsx";
        a.click();
        // 5.释放这个临时的对象url
        window.URL.revokeObjectURL(url);
      },
        (err) => {
          resolve(err.response);
        })
        .catch((error) => {
          reject(error);
        });
    },
    queryTotalDetails(){
      this.page = 1;
      this.getTotalDetails();
    },
    getStyle(from,state){
      let styleContent = "padding-left:5px;padding-right:5px;padding-top:3px;padding-bottom:5px;";

      if(from === 0){
        styleContent += "float:right;";
      } else if(from === 1) {
        styleContent += "color:#606266;margin-right:5px;";
      }

      if(state === 1){
        styleContent += "background-color:#FFF8DC;";
      } else if (state === 11) {
      styleContent += "background-color:#ffa41b;";
      } else if(state===3||(state>5 && state<11)) {
        styleContent += "background-color:#F08080;";
      } else if(state === 4) {
        styleContent += "background-color:#A9A9A9;";
      } else if(state === 5) {
        styleContent += "background-color:#87CEFA;";
      }

      return styleContent;
    },
    getStylecolor(from,state){
    let styleContentcolor = "width:10px; height:10px;border-radius:50%;margin-top:5px;margin-right:5px;";
    if(from === 0){
      styleContentcolor += "float:left;";
    } else if(from === 1) {
      styleContentcolor += "color:#606266;margin-right:5px;";
    }
    if(state === 1){
      styleContentcolor += "background-color:#FFF8DC;";
    } else if (state === 11) {
      styleContentcolor += "background-color:#ffa41b;";
    } else if(state === 3) {
      styleContentcolor += "background-color:#F08080;";
    } else if(state === 4) {
      styleContentcolor += "background-color:#A9A9A9;";
    } else if(state === 5) {
      styleContentcolor += "background-color:#87CEFA;";
    }
    return styleContentcolor;
  },
    // 显示详细
    handleShowDetails(item,lineName,licensePlateNumber,driverName){
      this.totalDetailsDetails = [];
      let taskObject = {
        Id:item.Id,
        VehicleId:item.VehicleId,
        DriverId:item.DriverId,
        IsCharter:item.IsCharter,
        LineName:lineName,
        ShiftName:item.ShiftName,
        Times:item.Times,
        LicensePlateNumber:licensePlateNumber,
        DriverName:driverName,
        DepartureTimeStr:item.DepartureTimeStr,
        SchedulingShiftRecordId:item.SchedulingShiftRecordId,
        RunCenterTaskId:item.RunCenterTaskId,
        ActualDepartureTimeStr:item.ActualDepartureTimeStr,
        // TimeDifference:item.TimeDifference===0?"":item.TimeDifference,
        TimeDifference:item.TimeDifference,
        StateName:item.StateName,
        State:item.State,
        StartTimeStr:item.StartTimeStr,
        EndTimeStr:item.EndTimeStr,
        StartAddr:item.StartAddr,
        EndAddr:item.EndAddr,
        DisposeResultsName: item.DisposeResultsName,
        AbnormalCause: item.AbnormalCause,
      };
      this.totalDetailsDetails[0] = taskObject;
      this.taskDetailsFormVisible = true;
    },     
   
    //获取统计明细列表
    getTotalDetails() {
      let _this = this;
      let para = {
        busLinesId: _this.filters.busLinesId,
        shiftName: _this.filters.shiftName,
        driverId: _this.filters.driverId,
        vehicleId: _this.filters.vehicleId,
        taskState: _this.filters.taskState,
        departureDate: _this.filters.departureDate,
        page: _this.page,
        pageSize: _this.pageSize
      };
      _this.listLoading = true;
      getTotalDetailsListPage(para).then(res => {
        _this.total = res.data.dataCount;
        _this.totalDetailsList = res.data.data;
        _this.listLoading = false;
      });
    },
    getBusLines(pageSizePara){
      getBusLinesListPage(pageSizePara).then(res => {
        this.busLiness = res.data.response.data;
    });
  },
    getDriverList(){
      let driverPara = {
        companyId: "",
        driverName: "",
        employmentStatus: "",
        page: 1,
        pageSize: 200
      };
      getDriverListPage(driverPara).then(res => {
        this.driverList = res.data.response.data;
      });
    },
    getVehiclesList(){
      let vehiclesPara = {
        companyId: '',
        busLinesId: '',
        licensePlateNumber: '',
        terminalsId: '',
        simId: '',
        page: 1,
        pageSize: 200
      };
      getVehiclesListPage(vehiclesPara).then(res => {
        this.vehicleList = res.data.response.data;
      });
    },
    getShiftNameList(){
      let para = {
      };
      getClassSubitem(para).then(res => {
        this.shiftNameList = res.data;
      });
    }, 
    //查看操作日记
    lookUpOperateDataLog() {
    
    this.TwoTableOperateDataLogFormVisible = true;
    this.oneEntityName= 'RunCenterTask';
    this.twoEntityName="Scheduling";
    this.oneEntityKey =  this.currentRow.RunCenterTaskId;
    this.twoEntityKey=this.currentRow.SchedulingId;
   }, 
    //查看任务详情操作日记
    taskDetailLookUpOperateDataLog() {
    
     this.TwoTableOperateDataLogFormVisible = true;
     this.oneEntityName= 'RunCenterTask';
     this.twoEntityName="SchedulingShiftRecord";
     this.oneEntityKey =  this.currentRow.RunCenterTaskId;
     this.twoEntityKey=this.currentRow.SchedulingShiftRecordId;
    },
    //显示异常处理界面
    handleAbnormalDispose() {
      this.AbnormalFormVisible = true;
      let row = this.currentRow;
      this.AbnormalForm = Object.assign({}, row);
    },   
    AbnormalSubmit: function () {
      this.$refs.AbnormalForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.AbnormalLoading = true;
            let para = Object.assign({}, this.AbnormalForm);
            AbnormalDisposeUser(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.AbnormalLoading = false;
                return;
              }
              if (res.data.success) {
                this.AbnormalLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["AbnormalForm"].resetFields();
                this.taskDetailsFormVisible = false;
                this.AbnormalFormVisible = false;
                this.getTotalDetails();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    getButtonList2(routers) {
      let _this = this;
      routers.forEach(element => {
        let path = this.$route.path.toLowerCase();
        if (element.path && element.path.toLowerCase() == path) {
          _this.buttonList = element.children;
          return;
        } else if (element.children) {
          _this.getButtonList(element.children);
        }
      });
    }
  },
  mounted() {
    let pageSizePara = {
      pageSize: 100
    };
    this.getBusLines(pageSizePara);
    this.getDriverList();
    this.getVehiclesList();
    this.getShiftNameList();
    this.getTotalDetails();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    let para = {
      dictName: "处理结果",
      dictCode: "DisposeResults",
      pageSize: 100,
    };
    getDictionaryListPageByDictNameAndDictCode(para).then((res) => {
      this.disposeResultsModeList = res.data.data;
    });
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);
    //第二种写法，封装到 permissionRouter.js 中
    this.buttonList = getButtonList(this.$route.path, routers); 
    this.operationButtonList = getOperationButtonList(this.$route.path, routers); 
  }
}
</script>

<style scoped></style>
    
</style>
  